// src/pages/Pedido/Cart.js
import { formatarVariacoes } from '../../utils/VariacaoUtils';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/Form/Header';
import Footer from '../../components/Form/Footer';
import MainContent from '../../components/Form/MainContent';
import { FaPlus, FaTrashAlt, FaCheck, FaShoppingCart } from 'react-icons/fa'; // Importando ícones
import { BsWhatsapp } from "react-icons/bs"; // Ícone do WhatsApp
import './Cart.css';  // Importar o arquivo CSS externo.
import { formatCurrency } from '../../utils/numberUtils';
import { useStoreStatus } from '../../contexts/useStoreStatus';
import Modal from '../../components/Modal/Modal';
import { useCart } from '../../contexts/CartContext';
import { useApi } from '../../hooks/useApi';
import { formatPedidoItemConjuntoQuantidade, getPedidoItemConjuntosAgrupados } from '../../utils/pedidoItemConjuntoUtils';
import SelecaoVariacoes from '../../components/SelecaoVariacoes';
import { obterErrosVariacoes } from '../../utils/VariacaoUtils';
import { aplicarEscolhasCarrinho, atualizarCarrinhoVariacoes, validarVariacoesCarrinho } from '../../utils/CarrinhoVariacaoUtils';
import { applyImageFallback } from '../../utils/imageUtils';

const Cart = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [erroVariacoes, setErroVariacoes] = useState('');
  const [isCheckingStoreStatus, setIsCheckingStoreStatus] = useState(false);
  const [cart, setCart] = useState(JSON.parse(localStorage.getItem('cart')) || []);
  const navigate = useNavigate();
  const { msgStorageClose, refreshStoreStatus } = useStoreStatus();
  const { setCartItemCount, setCartItemTotal, cartItemTotal } = useCart(); 
  const [whatsappLink, setWhatsappLink] = useState('');
  const { buildApiUrl, fetchData } = useApi();
  const cartQuantity = cart.reduce((total, item) => total + (item.qtde || 0), 0);

  useEffect(() => {
    const fetchConfig = async () => {
      let configPedido;
      try {
        configPedido = await fetchData('/ConfigPedido');        
      } catch (error) {
        console.error('Erro ao obter configPedido:', error);
        // setErrorMessage está sendo usado mas não foi definido no componente
      }

      if (configPedido) {
        const whatsappNumber = "+55" + configPedido.telefonePedido;
        setWhatsappLink(`https://wa.me/${whatsappNumber}?text=Olá, gostaria de saber sobre o funcionamento do estabelecimento.`);
      }
    };

    fetchConfig();
  }, []);

  const gravarCarrinho = lista => {
    setCart(lista); localStorage.setItem('cart', JSON.stringify(lista));
    setCartItemCount(lista.reduce((total,item) => total + Number(item.qtde || 0),0));
    setCartItemTotal(lista.reduce((total,item) => total + Number(item.valorTotal || 0),0));
  };
  useEffect(() => {
    let ativo = true;
    atualizarCarrinhoVariacoes(JSON.parse(localStorage.getItem('cart')) || [], fetchData)
      .then(lista => { if (ativo) gravarCarrinho(lista); })
      .catch(erro => { if (ativo) setErroVariacoes(erro.message); });
    return () => { ativo=false; };
  }, []);

  const removeItem = (index) => {
    const updatedCart = [...cart];
    updatedCart.splice(index, 1);

    // Atualiza o estado e localStorage
    setCart(updatedCart);
    localStorage.setItem('cart', JSON.stringify(updatedCart));

    // Recalcula quantidade e total usando updatedCart
    const count = updatedCart.reduce((acc, item) => acc + item.qtde, 0);
    setCartItemCount(count);

    const totalAmount = updatedCart.reduce((sum, item) => sum + item.valorTotal, 0);
    setCartItemTotal(totalAmount);

    localStorage.setItem('totalItem', JSON.stringify(totalAmount));
  };


  const handleCheckout = async () => {
    setIsCheckingStoreStatus(true);

    try {
      const atualizado = await atualizarCarrinhoVariacoes(cart, fetchData);
      gravarCarrinho(atualizado);
      try { validarVariacoesCarrinho(atualizado); }
      catch (erro) { setErroVariacoes(erro.message); return; }
      // Verifica o status da loja antes de prosseguir para o checkout
      const statusAtualizado = await refreshStoreStatus();

      if (statusAtualizado?.aberto) {
        navigate('/endereco');
      } else {
        setModalIsOpen(true);
      }
    } catch (error) {
      setErroVariacoes(error.message || 'Não foi possível conferir as variações. Tente novamente.');
      return;
    } finally {
      setIsCheckingStoreStatus(false);
    }
  };

  const chooseAnotherItem = () => {
    navigate('/ordermenu'); // Ajuste o caminho para a página de produtos conforme necessário
  };

  const getAdicionaisSelecionados = (item) => {
    if (Array.isArray(item.adicionaisSelecionados) && item.adicionaisSelecionados.length > 0) {
      return item.adicionaisSelecionados.map((adicional) => ({
        descricao: adicional.descricao || adicional.adicional?.descricao || 'Adicional',
        valor: adicional.preco ?? adicional.valor ?? adicional.adicional?.preco ?? 0
      }));
    }

    if (Array.isArray(item.pedidoItemAdicionais) && item.pedidoItemAdicionais.length > 0) {
      return item.pedidoItemAdicionais.map((adicional) => ({
        descricao: adicional.adicional?.descricao || adicional.descricao || 'Adicional',
        valor: adicional.valor ?? adicional.preco ?? adicional.adicional?.preco ?? 0
      }));
    }

    return [];
  };

  return (
    <>
      <Header titulo="Carrinho" />
      <MainContent className="cart-main">
      <section className="cart-page" aria-labelledby="cart-page-title">
        {cart.length === 0 ? (
          <div className="cart-empty-state">
            <span className="cart-empty-icon" aria-hidden="true">
              <FaShoppingCart />
            </span>
            <h2 id="cart-page-title">Seu carrinho está vazio</h2>
            <p>Escolha seus produtos favoritos para começar o pedido.</p>
            <button type="button" onClick={chooseAnotherItem} className="cart-empty-button">
              <FaPlus aria-hidden="true" />
              Explorar cardápio
            </button>
          </div>
        ) : (
          <div className="cart-layout">
            <div className="cart-products">
              <div className="cart-section-heading">
                <div>
                  <span>Revise seu pedido</span>
                  <h2 id="cart-page-title">Itens do carrinho</h2>
                </div>
                <p>{cartQuantity} {cartQuantity === 1 ? 'item' : 'itens'}</p>
              </div>

            {cart.map((item, index) => {
              const adicionais = getAdicionaisSelecionados(item);
              const conjuntos = getPedidoItemConjuntosAgrupados(item.pedidoItemConjuntos);

              return (
              <article key={index} className="cart-product-card">
                <header className="cart-product-header">
                  <div>
                    <span>Item {index + 1}</span>
                    <h3>{item.descricao}</h3>
                  </div>
                  <button
                    type="button"
                    onClick={() => removeItem(index)}
                    className="cart-remove-button"
                    aria-label={`Excluir ${item.descricao} do carrinho`}
                  >
                    <FaTrashAlt aria-hidden="true" />
                    <span>Excluir</span>
                  </button>
                </header>

                <div className="cart-product-body">
                  <img
                    src={item.imagemId
                      ? buildApiUrl('/ProdutoDelivery/ProdutoImagemArquivo', { produtoId: item.id })
                      : '/images/image_default.jpg'}
                    alt={item.descricao || 'Produto'}
                    className="cart-product-image"
                    onError={applyImageFallback}
                  />

                  <div className="cart-product-details">
                    <SelecaoVariacoes produto={item} escolhas={item.pedidoItemVariacoes || []}
                      erros={obterErrosVariacoes(item, item.pedidoItemVariacoes)}
                      onChange={escolhas => { gravarCarrinho(cart.map((atual,i) => i === index ? aplicarEscolhasCarrinho(atual, atual, escolhas) : atual)); setErroVariacoes(''); }} />
                    <div className="cart-product-metadata">
                      <span>Quantidade<strong>{item.qtde}</strong></span>
                    {/* <p className="item-info-text"><strong>Val. Un:</strong> {formatCurrency(item.preco)}</p> */}
                      <span>Total<strong>{formatCurrency(item.valorTotal)}</strong></span>
                    </div>

                    {formatarVariacoes(item) && (
                      <div className="cart-customization-group">
                        <h4>Variações</h4>
                        <p>{formatarVariacoes(item)}</p>
                      </div>
                    )}

                    {adicionais.length > 0 && (
                      <div className="cart-customization-group">
                        <h4>Adicionais</h4>
                        <ul>
                        {adicionais.map((adicional, adicionalIndex) => (
                          <li
                            key={`${adicional.descricao}-${adicionalIndex}`}
                          >
                            <span>+ {adicional.descricao}</span>
                            {adicional.valor > 0 && ` (${formatCurrency(adicional.valor * item.qtde)})`}
                          </li>
                        ))}
                        </ul>
                      </div>
                    )}

                    {conjuntos.map((conjunto) => (
                      <div key={conjunto.nomeConjunto} className="cart-customization-group">
                        <h4>{conjunto.nomeConjunto}</h4>
                        <ul>
                        {conjunto.itens.map((conjuntoItem, conjuntoItemIndex) => {
                          const valorAdicional = parseFloat(conjuntoItem.valorAdicional ?? conjuntoItem.ValorAdicional);
                          const descricao = conjuntoItem.descricao || conjuntoItem.Descricao || 'Item do conjunto';

                          return (
                          <li
                            key={`${conjuntoItem.conjuntoId ?? conjuntoItem.ConjuntoId}-${conjuntoItem.conjuntoItemId ?? conjuntoItem.ConjuntoItemId}-${conjuntoItemIndex}`}
                          >
                            <span>{formatPedidoItemConjuntoQuantidade(conjuntoItem, item.pedidoItemConjuntos)} {descricao}</span>
                            {valorAdicional > 0 && ` (+ ${formatCurrency(valorAdicional)})`}
                          </li>
                          );
                        })}
                        </ul>
                      </div>
                    ))}

                    {item.observacao && (
                      <div className="cart-observation">
                        <strong>Observação</strong>
                        <p>{item.observacao}</p>
                      </div>
                    )}
                  </div>
                </div>
              </article>
              );
            })}
            </div>

            <aside className="cart-summary" aria-label="Resumo do pedido">
              <span className="cart-summary-eyebrow">Resumo do pedido</span>
              <h2>Pronto para finalizar?</h2>
              <div className="cart-summary-row">
                <span>Quantidade</span>
                <strong>{cartQuantity} {cartQuantity === 1 ? 'item' : 'itens'}</strong>
              </div>
              <div className="cart-summary-row cart-summary-total">
                <span>Total</span>
                <strong>{formatCurrency(cartItemTotal)}</strong>
              </div>
              <button type="button" onClick={chooseAnotherItem} className="cart-continue-button">
                <FaPlus aria-hidden="true" /> Escolher outro item
              </button>
              <button
                type="button"
                onClick={handleCheckout}
                className="cart-checkout-button"
                disabled={isCheckingStoreStatus}
              >
                <FaCheck aria-hidden="true" />
                {isCheckingStoreStatus ? 'Verificando...' : 'Finalizar pedido'}
              </button>
            </aside>
          </div>
        )}
      </section>
      </MainContent>
      {/* <Footer /> */}
      <Modal 
        show={modalIsOpen} 
        onClose={() => setModalIsOpen(false)} 
        message={
          <>
            <p>{msgStorageClose}</p>
            
            <a 
              href={whatsappLink} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="whatsapp-button"
            >
              <BsWhatsapp className="whatsapp-icon" /> Contatar via WhatsApp
            </a>
          </>
        } 
      />
    </>
  );
};

export default Cart;
